/**
 * Shell v2 — flag runtime a 3 livelli (query param → localStorage → env).
 *
 * Un solo flag governa shell a sidebar E home v2: evita la matrice di stati
 * misti (sidebar nuova + home vecchia) in test e analytics.
 *
 * Livelli, in ordine di precedenza:
 *   1. `?shell=v2` / `?shell=v1` nell'URL — scrive anche localStorage, così un
 *      link di QA su preproduction resta attivo dopo la prima apertura;
 *   2. `localStorage.studierAI_shell_version`;
 *   3. `REACT_APP_SHELL_V2 === 'true'` (pattern featureFlags.js: flag assente
 *      = shell vecchia, default sicuro; il flip = env var + rebuild, mai revert).
 *
 * Valutato UNA VOLTA a module-load, NON reattivo, di proposito: un flag
 * reattivo forzerebbe un re-render del fork in layout.js e rischierebbe il
 * remount di GamificationProvider (vietato — vedi commento in layout.js).
 * Cambiare shell richiede un reload della pagina.
 */

const STORAGE_KEY = 'studierAI_shell_version';

const readOverride = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const fromQuery = params.get('shell');
    if (fromQuery === 'v2' || fromQuery === 'v1') {
      localStorage.setItem(STORAGE_KEY, fromQuery);
      return fromQuery;
    }
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'v2' || stored === 'v1') return stored;
  } catch (_) {
    /* storage o URL non disponibili: si cade sull'env */
  }
  return null;
};

const override = typeof window !== 'undefined' ? readOverride() : null;

const SHELL_V2 = override
  ? override === 'v2'
  : process.env.REACT_APP_SHELL_V2 === 'true';

export const isShellV2Enabled = () => SHELL_V2;
